interface GetAddendumModeTooltipKeyParams {
  canEnterAddendum: boolean;
  hasActiveSession: boolean;
  isCurrentUserSession: boolean;
}

export function getAddendumModeTooltipKey({
  canEnterAddendum,
  hasActiveSession,
  isCurrentUserSession,
}: GetAddendumModeTooltipKeyParams): string {
  if (canEnterAddendum) {
    return 'FCT.ADDENDUM.STUDY_MODE_DIALOG.TOOLTIP.ADDENDUM_MODE';
  }

  if (hasActiveSession && !isCurrentUserSession) {
    return 'FCT.ADDENDUM.STUDY_MODE_DIALOG.TOOLTIP.ADDENDUM_IN_PROGRESS';
  }

  return 'FCT.ADDENDUM.STUDY_MODE_DIALOG.TOOLTIP.INSUFFICIENT_PERMISSIONS';
}
